module.exports = __webpack_public_path__ + "img/2.60b39a05.jpg";